import * as React from "react";
const MapPinIcon = ({ brandingColor = "#22880" }: any) => (
  <svg
    width="64"
    height="64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
    preserveAspectRatio="xMidYMin meet"
    aria-hidden="false"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26 8c9.941 0 18 8.059 18 18 0 8.67-13.685 28.072-17.19 32.899a1.005 1.005 0 0 1-1.62 0C21.684 54.072 8 34.669 8 26c0-9.941 8.059-18 18-18Z"
      fill="#F2FCEE"
    ></path>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32 2c9.941 0 18 8.059 18 18 0 8.67-13.685 28.072-17.19 32.899a1.005 1.005 0 0 1-1.62 0C27.684 48.072 14 28.669 14 20c0-9.941 8.059-18 18-18Z"
      fill="#fff"
      stroke="#5C5C5C"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32 28a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"
      fill="#F2FCEE"
      stroke={brandingColor}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M47.944 47.424C55.229 48.867 60 51.274 60 54c0 4.419-12.533 8-28 8S4 58.419 4 54c0-2.72 4.75-5.123 12-6.568"
      stroke="#5C5C5C"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);
export default MapPinIcon;
